import { assetsUrl, mkIcon } from './mkIcon'

export const mkEngancheIconOld = () => mkIcon({ fillColor: '0000FF' })

export const mkEngancheIcon = () => `${assetsUrl}blue-map-pin.png`
